// Storefront: tiny progressive enhancements (pages work without JavaScript).
import { initAddToCart } from "./storefront/cart.js";
import { initCheckout } from "./storefront/checkout.js";
import { initFilters } from "./storefront/filters.js";
import { initProduct } from "./storefront/product.js";
import { initSearch } from "./storefront/search.js";
import { initWishlist } from "./storefront/wishlist.js";

// Mobile menu toggle
document.addEventListener("click", (event) => {
	const toggle = event.target.closest("[data-nav-toggle]");
	if (!toggle) return;
	const nav = document.getElementById(toggle.getAttribute("aria-controls"));
	const open = toggle.getAttribute("aria-expanded") === "true";
	toggle.setAttribute("aria-expanded", String(!open));
	if (nav) nav.classList.toggle("is-open", !open);
});

// Language switcher: remember the choice for the next visit of the plain home page "/" (the
// page's language always comes from its URL; M6-01)
document.addEventListener("click", (event) => {
	const link = event.target.closest("[data-set-lang]");
	// the value is a language code the server rendered (the store's languages only)
	if (link)
		document.cookie = `sc_lang=${link.dataset.setLang};path=/;max-age=31536000;SameSite=Lax`;
});

// Cart quantities: submit on change
document.addEventListener("change", (event) => {
	if (event.target.matches("[data-auto-submit]")) event.target.form.submit();
});

// one island failing (e.g. markup an owner rearranged) must not stop the others
const safely =
	(init) =>
	(...args) => {
		try {
			init(...args);
		} catch (error) {
			console.error(error); // eslint-disable-line no-console
		}
	};
document.querySelectorAll("[data-product]").forEach(safely(initProduct));
document.querySelectorAll("[data-collection]").forEach(safely(initFilters));
document.querySelectorAll("[data-search]").forEach(safely(initSearch));
safely(initWishlist)();
document.querySelectorAll("[data-add-to-cart]").forEach(safely(initAddToCart));
document.querySelectorAll("[data-checkout]").forEach(safely(initCheckout));

// Password fields: show / hide (the button is hidden without JavaScript)
document.querySelectorAll("[data-password-toggle]").forEach((button) => {
	const input = document.getElementById(button.getAttribute("aria-controls"));
	if (!input) return;
	button.hidden = false;
	button.addEventListener("click", () => {
		const show = input.type === "password";
		input.type = show ? "text" : "password";
		button.setAttribute("aria-pressed", String(show));
		button.textContent = show ? button.dataset.hide : button.dataset.show;
	});
});

// Forms that ask before submitting (e.g. removing an address)
document.addEventListener("submit", (event) => {
	const message = event.target.dataset && event.target.dataset.confirm;
	if (message && !window.confirm(message)) event.preventDefault();
});

// Review form: check photos before uploading them, and send it once
document.addEventListener("submit", (event) => {
	const form = event.target;
	if (!form.matches || !form.matches("[data-review-form]")) return;
	const input = form.querySelector("input[type=file]");
	const files = input ? [...input.files] : [];
	const problem =
		files.length > 3
			? form.dataset.tooMany
			: files.some((f) => f.size > 2 * 1024 * 1024)
			? form.dataset.tooBig
			: "";
	if (problem || form.dataset.sent) {
		event.preventDefault();
		if (problem) window.alert(problem);
		return;
	}
	form.dataset.sent = "1";
});

// Checkout: one Place order only (the server is idempotent too). Other buttons of the form
// (discount code, the hidden Enter-refresh) re-check the page; once an order is on its way,
// every further submit of the form is blocked.
let lastSubmitter = null; // browsers without event.submitter (Safari < 15.4)
document.addEventListener("click", (event) => {
	const button = event.target.closest && event.target.closest("[data-checkout] [type=submit]");
	if (button) lastSubmitter = button;
});
document.addEventListener("submit", (event) => {
	const form = event.target;
	const button = form.matches("[data-checkout]") && form.querySelector("[data-place-order]");
	if (!button) return;
	if (button.dataset.sent) return event.preventDefault();
	const submitter = event.submitter || lastSubmitter;
	lastSubmitter = null;
	if (submitter && submitter !== button) return;
	button.dataset.sent = "1";
	button.dataset.label = button.textContent;
	button.textContent = button.dataset.busy || button.textContent;
	button.setAttribute("aria-disabled", "true");
});
// back/forward cache restores the page as it was: make Place order usable again (the form still
// carries the same idempotency key, so submitting it again answers with the same order)
window.addEventListener("pageshow", (event) => {
	if (!event.persisted) return;
	document
		.querySelectorAll("[data-checkout] [data-place-order][data-sent]")
		.forEach((button) => {
			delete button.dataset.sent;
			button.textContent = button.dataset.label || button.textContent;
			button.removeAttribute("aria-disabled");
		});
});
